module.exports = __webpack_public_path__ + "static/asen-2c807f39afea669c16370cc182e7f8bc.jpg";